import PropTypes from 'prop-types';
import ModalClickable from '../../../layouts/modals/ModalClickable';
import ModalOptions from '../../../layouts/modals/ModalOptions';

function ModalesDatosEscolares({
  isModalShown,
  isModalShown2,
  url,
  raw,
  setIsModalShown2,
}) {
  return (
    <>
      {isModalShown ? (
        <ModalClickable header="Un usuario ha modificado este alumno recientemente." />
      ) : (
        ''
      )}
      {isModalShown2 ? (
        <ModalOptions
          header="¿Desea realizar estos cambios?"
          url={url}
          raw={raw}
          load={setIsModalShown2}
          text1="Cancelar"
          color1="danger"
          text2="Aceptar"
          color2="primary"
        />
      ) : (
        ''
      )}
    </>
  );
}

ModalesDatosEscolares.propTypes = {
  isModalShown: PropTypes.bool.isRequired,
  isModalShown2: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  raw: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setIsModalShown2: PropTypes.func.isRequired,
};

export default ModalesDatosEscolares;
